<template>
  <div class="base-item shadow d-flex align-start">
    <div
      :class=" [
        menuItems ? 'pl-6 pr-0' : 'px-6',
        itemDisabled ? 'disabled' : '',
        'base-item-content d-flex align-center justify-start px-6',
      ]"
    >
      <p :class="[shouldGrow, 'base-item-label']">
        {{ item.name }}
        <span
          v-if="item.isPrivate"
          class="private"
        >
          PRIVATE
        </span>
      </p>
      <p
        v-if="item[listFieldNames.main]"
        class="px-6"
      >
        {{ item[listFieldNames.main] }}
      </p>
      <div class="d-flex align-center tall ml-auto">
        <p :class="[highlight, 'base-item-status px-6']">
          {{ item[listFieldNames.status] }}
        </p>
        <DpplToggleButton
          v-if="isTeamAdmin"
          :model-value="toggleModel"
          :label="label"
          class="mx-6 toggle"
          @update:model-value="onToggleClick()"
        />
        <MenuList
          v-if="!integrated && hasItems && isTeamAdmin"
          :menu-items="menuItems"
          :item="item"
          v-bind="$attrs"
        />
      </div>
    </div>
  </div>
</template>

<script>

import DpplToggleButton from '@/components/datapeople/DpplToggleButton.vue';
import MenuList from './MenuList.vue';

export default {
  name: 'ToggleListItem',
  components: {
    DpplToggleButton,
    MenuList,
  },
  props: {
    item: { type: Object, default: () => ({}) },
    toggleLabels: { type: Object, default: () => ({}) },
    toggleActions: { type: Object, default: () => ({}) },
    listFieldNames: { type: Object, default: () => ({}) },
    integrated: { type: Boolean, default: false },
    isTeamAdmin: { type: Boolean, default: false },
    showItemProgressId: { type: Number, default: null },
    itemDisabled: { type: Boolean, default: false },
    menuItems: { type: Array, default: () => [] },
  },
  emits: ['toggleClick'],
  data() {
    return {
      toggleModel: this.item[this.listFieldNames.toggleModel],
    };
  },
  computed: {
    label() {
      return this.toggleModel ? this.toggleLabels.active : this.toggleLabels.inactive;
    },
    action() {
      return this.toggleModel ? this.toggleActions.active : this.toggleActions.inactive;
    },
    shouldGrow() {
      return this.item[this.listFieldNames.main] ? '' : ' flex-grow-1';
    },
    highlight() {
      return this.item[this.listFieldNames.status] === 'Active' ? 'highlight' : '';
    },
    hasItems() {
      return this.menuItems.length;
    },
  },
  methods: {
    onToggleClick() {
      this.toggleModel = !this.toggleModel;
      const data = {
        action: this.action,
        id: this.item.id,
      };
      this.$emit('toggleClick', { apiName: 'post', data });
    },
  },
};
</script>

<style scoped lang="less">
  .base-item {
    width: 100%;
    height: 68px;
    background-color: white;
    border-bottom: 1px solid @stroke-default;
  }
  .base-item-content {
    height: 100% !important;
    width: 100%;
    &.disabled {
      opacity: .4;
      pointer-events: none;
    }
  }
  .base-item-label {
    width: 200px;
    font-weight: 500 !important;
  }
  .base-list-item::before {
    background-color: @text-brand;
  }
  .wide {
    width: 100%;
  }
  .tall {
    height: 100%;
  }
  .toggle {
    width: 100px;
  }
  .highlight {
    color: @text-brand;
  }
  .private {
    color: @basic-red;
  }
</style>
